<template>
    <div v-show="!isLoading" v-if="false">
        <div v-if="!isLoggedIn && false">Login...</div>

        <div v-if="isLoggedIn">

            <div v-show="!isSaved">
                <button @click="save()"
                        class="cursor-pointer rounded py-2 block text-grey-dark font-bold">
                    <i class="fa fa-save"></i> Save
                </button>
            </div>

            <p v-show="isSaved" class="py-2 block text-grey-dark">saved</p>

        </div>
    </div>
</template>

<script>

    export default {
        name: "Save",

        props: ['user'],

        computed: {
            isLoading() {
                return this.$store.state.loading;
            },
            isLoggedIn() {
                return this.user !== 0;
            },
            isSaved() {
                return this.$store.state.rawData.user_id === this.user;
            }
        },

        methods: {
            save() {
                http.post("/en/dashboards/" + this.$store.state.id, {
                    _method: 'put',
                    action: 'add',
                })
                    .then(function (response) {

                    });
            }
        }

    }
</script>

<style scoped>

</style>
